import { AgGridReact } from 'ag-grid-react'; // React Data Grid Component
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';
import { FETCH_T_PDCAS } from '../../queries/pdca_t_pdca.queries.type';
import { useJigyoListPresenter } from './jigyoList.presenter.hooks';
import { TContentsContentParams } from '@/shared/t-contents-params';
import { IContentsContentElem } from 'app-template-lib/utils';
import MultiSelect from '../shared/ui/multi-select';
import { Button, Input } from 'app-template-lib/components/shadcn';
import { Download } from 'lucide-react';
import { FETCH_M_LG_CONFIG } from '@/main/queries/setting_m_lg_config.queries.type';

// import { IContentsContent } from 'app-template-lib/utils';

// Register all Community features
ModuleRegistry.registerModules([AllCommunityModule]);

//拡張
interface IJigyoListPresenterProps<U> extends IContentsContentElem<U> {
    data: FETCH_T_PDCAS | undefined;
    lgcode: string;
    jigyoYear: string;
    lgConfigData: FETCH_M_LG_CONFIG | undefined;
    onNavigate: (jigyoID: string) => void;
}

// マージ
// interface IContentsContentElem<U> extends IContentsContent<U> {
//     data: FETCH_T_PDCAS | undefined;
//     lgcode: string;
//     jigyoYear: string;
//     onNavigate: (jigyoID: string) => void;
// }

export function JigyoList(props: IJigyoListPresenterProps<TContentsContentParams>) {
    // export function JigyoList(props: IContentsContentElem<TContentsContentParams>) {
    const { data, jigyoYear, lgConfigData, onNavigate } = props;

    // Presenterのカスタムフック
    const { jigyoListGridProps, divisionMultiSelectProps, seisakuMultiSelectProps, exportCSVButtonProps, keywordSearchInputProps } =
        useJigyoListPresenter(jigyoYear, data, lgConfigData, onNavigate);

    return (
        <div>
            <div className="flex justify-between">
                <div className="flex justify-start flex-wrap mb-1">
                    <MultiSelect
                        {...seisakuMultiSelectProps}
                        name="政策"
                        idKey="id"
                        valueKey="seisaku_shisaku_name"
                        countKey="count"
                        maxViewCount={1}
                        className="my-1 mr-2"
                        visibleItemCount={false}
                    />
                    <MultiSelect
                        {...divisionMultiSelectProps}
                        name="担当課"
                        idKey="id"
                        valueKey="division_name"
                        countKey="count"
                        className="my-1 mr-2"
                        visibleItemCount={false}
                    />
                </div>

                <div className="flex max-w-[50%]">
                    <Input {...keywordSearchInputProps} className="mb-0 h-11 bg-white items-end max-w-[100%}] align-bottom md:mb-1 mr-2" />
                    <Button {...exportCSVButtonProps} className="my-1  h-fit hidden md:flex">
                        <Download />
                        CSV出力
                    </Button>
                </div>
            </div>
            <div style={{ height: '75vh' }}>
                <AgGridReact {...jigyoListGridProps} />
            </div>
        </div>
    );
}
